import EducationInfoFormStep from './EducationInfoFormStep';
import FinancingInfoFormStep from './FinancingInfoFormStep';
import PersonalInformationStep from './PersonalInformationStep';
import ProfileSignAgreementStep from './ProfileSignAgreementStep';
import ProfileStartSignAgreementStep from './ProfileStartSignAgreementStep';

export {
  EducationInfoFormStep,
  FinancingInfoFormStep,
  PersonalInformationStep,
  ProfileSignAgreementStep,
  ProfileStartSignAgreementStep,
};
